module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/email-general-icon-b2a0be360184181a1c747cd7ee52e88b.svg";